var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.codingObjectReady)?_c('WebQuestionEditor',{attrs:{"mode":"add","codingObject":_vm.codingObject},on:{"CODING_OBJECT_EMITTED":_vm.saveQuestionAndGoBack}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }